module.exports = __webpack_public_path__ + "img/Table-copyright.cb77a771.svg";